import { useState, useEffect } from "react";
import { Download, Lock, MapPin, Phone, Mail, Globe, Award, Briefcase, GraduationCap, Languages, Sparkles, Shield } from "lucide-react";

const PASSWORD = "goodchoice";
const STORAGE_KEY = "lk_resume_unlocked";

const resume = {
  name: "לב קזריאן",
  tagline: "מנהל בתחום האירוח · איש מכירות · מחבר ספרים · יזם",
  contact: {
    phone: "053-531-9943",
    email: "email@levkazaryan.com",
    location: "ת.ד. 2209, אילת",
    website: "levkazaryan.com",
  },
  summary:
    "בן 31, גרוש + 2. אוכל להעיד על עצמי כאדם יוזם, לומד במהירות ובעל יכולת להוביל פרויקטים משלב הרעיון ועד לביצוע. בעל חשיבה יצירתית, עם גישה פרקטית לפתרון בעיות. שואף תמיד להשתפר, ללמוד ולהשפיע על הסביבה שבה אני עובד. עסקתי בעבודה ומחוץ לעבודה בתחומים שהוכיחו את התכונות האלו. מחפש אתגר חדש והזדמנות להתפתח בחברתכם.",
  experience: [
    {
      company: "רשת מלונות אסטרל — מלכת שבא ואריאה",
      role: "מנהל קבלה · מנהל יחסי ציבור · מבקר מלון",
      dates: "2019 – היום",
      bullets: [
        "התנהלות שוטפת בקבלה, כולל הכרה מעמיקה של מערכות אופטימה, אוסקר, סינמקס וסמארט-באטלר.",
        "סגירת חשבונות על סך מאות אלפי ומיליוני שקלים.",
        "התנהלות מול סוכני נסיעות גדולים, ביניהם אשת טורס, שטיח מעופף ועוד.",
        "ניהול צוות של כ-20 עובדים, 2 מנהלי ביניים ו-3 סגנים.",
        "הכנה והעברה של הדרכות מלון, ביניהן הדרכת מכירות והדרכת שירות.",
        "מענה לסיטואציות מאתגרות עם לקוחות בזמן אמת ואחרי השהות, כולל טיפול במכתבי תלונה.",
        "התנהלות שוטפת מול אנשים בכירים בישראל המגיעים למלון — מנכ\"לים, בעלי חברות, מפורסמים ובכירים.",
        "קידום המלון מול המתחרים באתרים כמו בוקינג, טריפאדוויזר, גוגל ועוד.",
        "ביקורת על עבודה עם כספים של עובדי המלון, מלאים, בלאי ועוד.",
        "עובד מצטיין רשתי לשנת 2019.",
      ],
    },
    {
      company: "זכות ויוזמה — מימוש זכויות רפואיות מול חברות הביטוח",
      role: "סוכן מכירות שטח",
      dates: "2018 – 2019",
      bullets: [
        "איתור וגיוס לקוחות תוך פרסום בשיטות שונות.",
        "פגישות בבית הלקוח וליווי צמוד לאורך כל התהליך.",
        "מתן מענה מהיר לבעיות בשטח.",
      ],
    },
    {
      company: "רשת Bar Perfume Feel",
      role: "מנהל סניף הדגל",
      dates: "2017 – 2018",
      bullets: [
        "ניהול רצפת המכירה בשיטת \"צייד\" וביצוע יעדי המכירות ברמה יומית וחודשית.",
        "ביצוע ראיונות, גיוס ובניית צוות כולל הכשרתו, ובנוסף הכשרת מנהלי סניפים.",
        "מעקב אחר המלאי, הזמנות ותפעול שוטף של הסניף.",
      ],
    },
    {
      company: "המכללה למנהל",
      role: "נציג טלמרקטינג",
      dates: "2016 – 2017",
      bullets: [],
    },
    {
      company: "רשת CASTRO",
      role: "נציג מכירות פרונטלי",
      dates: "2011 – 2016",
      bullets: [],
    },
  ],
  military: {
    title: "שירות צבאי — חיל השריון",
    dates: "2012 – 2015",
    role: "חובש פלוגתי, גדוד 74, חטיבה 188",
    body:
      "שחרור בדרגת סמל ראשון. תפקיד מורכב שדורש רמת אינטליגנציה גבוהה, רגישות, אהבת האדם, יכולת עבודה מהירה, קבלת החלטות ברגע האמת ובמצבי לחץ קיצוניים, ניהול לוח זמנים מופתי ויחסי אנוש מצוינים. כמו כן, התפקיד דרש ניהול ומעקב צמוד על מסמכים רפואיים של כלל חיילי הפלוגה ושמירה על אתיקה רפואית. במסגרת השירות השתתפתי במספר פעולות מבצעיות, ביניהן מבצע צוק איתן. בעל אות מלחמת צוק איתן.",
  },
  education: [
    {
      institution: "האקדמיה לפסיכולוגיה יישומית",
      degree: "מאסטר פרקטישינר NLP",
      dates: "2020",
    },
    {
      institution: "אלון אולמן",
      degree: "קוד הבמה — יצירת הרצאות ועמידה מול קהל",
      dates: "2021",
    },
    {
      institution: "BDO",
      degree: "קורס מנכ\"לים, כולל ניהול על פי יעדים (M.B.O.)",
      dates: "2024",
    },
  ],
  certifications: [
    { name: "מכירות", issuer: "מכללת מעוף", year: "2016" },
    { name: "ניהול צוות מנצח", issuer: "מכללת מעוף", year: "2019" },
    { name: "מאסטר פרקטישינר NLP", issuer: "האקדמיה לפסיכולוגיה יישומית", year: "2020" },
    { name: "קוד הבמה (עמידה מול קהל)", issuer: "אלון אולמן", year: "2021" },
    { name: "קורס מנכ\"לים (M.B.O.)", issuer: "BDO", year: "2024" },
  ],
  skills: [
    "ניהול צוות",
    "ניהול מכירות",
    "איתור וגיוס לקוחות",
    "ניהול מלאי",
    "הרצאות והדרכות",
    "טיפול בתלונות",
    "תקשורת בין-אישית",
    "התנהלות במצבי קיצון",
    "עיצוב גרפי בסיסי",
    "עבודה עם כלי AI",
  ],
  languages: [
    { name: "עברית", level: "שפת אם" },
    { name: "רוסית", level: "שפת אם" },
    { name: "אנגלית", level: "רמה טובה" },
  ],
  additional: [
    "מחבר הספר \"ארבעת הצבעים בתקשורת בין-אישית\".",
    "בעל רישיון נהיגה בתוקף.",
    "אשמח להרחיב על עצמי ולענות על כל שאלה בפגישה אישית.",
    "המלצות מכל המעסיקים יימסרו על פי דרישה.",
  ],
  // UI labels
  labels: {
    privateTag: "מוגן",
    pageTitle: "קורות חיים",
    passwordPlaceholder: "סיסמה",
    unlock: "פתח",
    passwordHint: "הדף הזה מוגן בסיסמה.",
    enterPassword: "הזינו את הסיסמה כדי להמשיך.",
    wrongPassword: "סיסמה שגויה. נסו שוב.",
    cv: "קורות חיים",
    download: "הורדת קובץ PDF",
    sectionAbout: "אודות",
    sectionExperience: "ניסיון תעסוקתי",
    sectionMilitary: "שירות צבאי",
    sectionEducation: "השכלה",
    sectionSkills: "כישורים",
    sectionLanguages: "שפות",
    sectionCertifications: "הסמכות",
    sectionAdditional: "מידע נוסף",
  },
};

function PasswordGate({ onUnlock }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const t = resume.labels;

  const submit = (e) => {
    e.preventDefault();
    if (value.trim().toLowerCase() === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      onUnlock();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <main
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "#0B1220" }}
      dir="rtl"
      data-testid="resume-password-gate"
    >
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full border mb-8" style={{ borderColor: "rgba(244, 237, 224, 0.2)" }}>
          <Lock size={22} className="text-parchment" />
        </div>
        <p className="mb-3" style={{ color: "#F4EDE0", opacity: 0.6, letterSpacing: "0.3em", fontSize: "11px", textTransform: "uppercase" }}>
          {t.privateTag}
        </p>
        <h1 className="text-3xl md:text-4xl font-serif mb-4" style={{ color: "#F4EDE0" }}>
          {t.pageTitle}
        </h1>
        <p className="text-sm mb-10 leading-relaxed" style={{ color: "#F4EDE0", opacity: 0.65 }}>
          {t.passwordHint}<br />{t.enterPassword}
        </p>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={t.passwordPlaceholder}
            autoFocus
            className="w-full px-5 py-3 bg-transparent border focus:outline-none text-center tracking-widest text-sm transition-colors"
            style={{
              borderColor: error ? "#c47878" : "rgba(244, 237, 224, 0.25)",
              color: "#F4EDE0",
            }}
            data-testid="resume-password-input"
          />
          <button
            type="submit"
            className="w-full px-5 py-3 border text-sm tracking-wide transition-all duration-500 hover:bg-parchment hover:text-navy"
            style={{
              borderColor: "rgba(244, 237, 224, 0.5)",
              color: "#F4EDE0",
            }}
            data-testid="resume-password-submit"
          >
            {t.unlock}
          </button>
          {error && (
            <p className="text-sm mt-2" style={{ color: "#c47878" }} data-testid="resume-password-error">
              {t.wrongPassword}
            </p>
          )}
        </form>
      </div>
    </main>
  );
}

function ResumeContent() {
  const t = resume.labels;
  return (
    <main
      className="min-h-screen pt-28 pb-24 px-6 md:px-10"
      style={{ backgroundColor: "#0B1220", color: "#F4EDE0" }}
      dir="rtl"
      data-testid="resume-page"
    >
      <article className="max-w-4xl mx-auto">
        {/* HEADER */}
        <header className="mb-20">
          <p className="mb-4" style={{ color: "#F4EDE0", opacity: 0.55, letterSpacing: "0.3em", fontSize: "11px", textTransform: "uppercase" }}>
            {t.cv}
          </p>
          <h1 className="text-5xl md:text-7xl font-serif leading-tight mb-4" style={{ color: "#F4EDE0" }}>
            {resume.name}
          </h1>
          <p className="text-lg md:text-xl italic mb-10" style={{ color: "#F4EDE0", opacity: 0.7 }}>
            {resume.tagline}
          </p>

          <div className="brush-divider mb-10" />

          <div className="grid sm:grid-cols-2 gap-4 text-sm mb-10" style={{ color: "#F4EDE0", opacity: 0.8 }}>
            <span className="flex items-center gap-3" dir="ltr"><Phone size={14} className="opacity-60" /> {resume.contact.phone}</span>
            <span className="flex items-center gap-3" dir="ltr"><Mail size={14} className="opacity-60" /> {resume.contact.email}</span>
            <span className="flex items-center gap-3"><MapPin size={14} className="opacity-60" /> {resume.contact.location}</span>
            <span className="flex items-center gap-3" dir="ltr"><Globe size={14} className="opacity-60" /> {resume.contact.website}</span>
          </div>

          <a
            href="/lev-kazaryan-resume.pdf"
            download="Lev-Kazaryan-Resume.pdf"
            className="inline-flex items-center gap-2 px-6 py-3 border text-sm tracking-wide transition-all duration-500 hover:bg-parchment hover:text-navy"
            style={{ borderColor: "rgba(244, 237, 224, 0.5)", color: "#F4EDE0" }}
            data-testid="resume-download-pdf"
          >
            <Download size={14} />
            {t.download}
          </a>
        </header>

        {/* SUMMARY */}
        <Section icon={<Sparkles size={14} />} title={t.sectionAbout}>
          <p className="text-base md:text-lg leading-relaxed" style={{ color: "#F4EDE0", opacity: 0.85 }}>
            {resume.summary}
          </p>
        </Section>

        {/* EXPERIENCE */}
        <Section icon={<Briefcase size={14} />} title={t.sectionExperience}>
          <div className="space-y-12">
            {resume.experience.map((job) => (
              <div key={job.company} data-testid={`resume-job-${job.company}`}>
                <div className="flex flex-wrap items-baseline justify-between gap-2 mb-1">
                  <h3 className="text-xl md:text-2xl font-serif" style={{ color: "#F4EDE0" }}>{job.company}</h3>
                  <span className="text-xs tracking-widest" style={{ color: "#F4EDE0", opacity: 0.5 }} dir="ltr">{job.dates}</span>
                </div>
                <p className="text-sm italic mb-4" style={{ color: "#F4EDE0", opacity: 0.65 }}>{job.role}</p>
                {job.bullets.length > 0 && (
                  <ul className="space-y-2 list-none">
                    {job.bullets.map((b, i) => (
                      <li key={i} className="text-sm md:text-base leading-relaxed pr-4 relative" style={{ color: "#F4EDE0", opacity: 0.8 }}>
                        <span className="absolute right-0 top-3" style={{ width: "8px", height: "1px", backgroundColor: "#F4EDE0", opacity: 0.4 }} />
                        {b}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </Section>

        {/* MILITARY */}
        <Section icon={<Shield size={14} />} title={t.sectionMilitary}>
          <div className="flex flex-wrap items-baseline justify-between gap-2 mb-1">
            <h3 className="text-xl md:text-2xl font-serif" style={{ color: "#F4EDE0" }}>{resume.military.title}</h3>
            <span className="text-xs tracking-widest" style={{ color: "#F4EDE0", opacity: 0.5 }} dir="ltr">{resume.military.dates}</span>
          </div>
          <p className="text-sm italic mb-4" style={{ color: "#F4EDE0", opacity: 0.65 }}>{resume.military.role}</p>
          <p className="text-sm md:text-base leading-relaxed" style={{ color: "#F4EDE0", opacity: 0.85 }}>
            {resume.military.body}
          </p>
        </Section>

        {/* EDUCATION */}
        <Section icon={<GraduationCap size={14} />} title={t.sectionEducation}>
          <div className="space-y-6">
            {resume.education.map((e) => (
              <div key={e.institution + e.dates} className="flex flex-wrap items-baseline justify-between gap-2">
                <div>
                  <h3 className="text-lg md:text-xl font-serif" style={{ color: "#F4EDE0" }}>{e.institution}</h3>
                  <p className="text-sm italic" style={{ color: "#F4EDE0", opacity: 0.7 }}>{e.degree}</p>
                </div>
                <span className="text-xs tracking-widest" style={{ color: "#F4EDE0", opacity: 0.5 }} dir="ltr">{e.dates}</span>
              </div>
            ))}
          </div>
        </Section>

        {/* SKILLS */}
        <Section icon={<Sparkles size={14} />} title={t.sectionSkills}>
          <div className="flex flex-wrap gap-3">
            {resume.skills.map((s) => (
              <span
                key={s}
                className="px-4 py-2 text-xs md:text-sm border tracking-wide"
                style={{ borderColor: "rgba(244, 237, 224, 0.25)", color: "#F4EDE0", opacity: 0.85 }}
              >
                {s}
              </span>
            ))}
          </div>
        </Section>

        {/* LANGUAGES */}
        <Section icon={<Languages size={14} />} title={t.sectionLanguages}>
          <div className="grid sm:grid-cols-3 gap-4">
            {resume.languages.map((l) => (
              <div key={l.name}>
                <p className="text-lg font-serif" style={{ color: "#F4EDE0" }}>{l.name}</p>
                <p className="text-xs tracking-widest" style={{ color: "#F4EDE0", opacity: 0.5 }}>{l.level}</p>
              </div>
            ))}
          </div>
        </Section>

        {/* CERTIFICATIONS */}
        <Section icon={<Award size={14} />} title={t.sectionCertifications}>
          <ul className="space-y-3">
            {resume.certifications.map((c) => (
              <li key={c.name + c.year} className="flex flex-wrap items-baseline justify-between gap-2 border-b pb-3" style={{ borderColor: "rgba(244, 237, 224, 0.1)" }}>
                <span style={{ color: "#F4EDE0", opacity: 0.9 }}>
                  <span className="font-serif">{c.name}</span>
                  <span className="text-xs italic mr-2" style={{ opacity: 0.7 }}>· {c.issuer}</span>
                </span>
                <span className="text-xs tracking-widest" style={{ color: "#F4EDE0", opacity: 0.5 }} dir="ltr">{c.year}</span>
              </li>
            ))}
          </ul>
        </Section>

        {/* ADDITIONAL */}
        <Section title={t.sectionAdditional}>
          <ul className="space-y-2 list-none">
            {resume.additional.map((a, i) => (
              <li key={i} className="text-sm md:text-base leading-relaxed pr-4 relative" style={{ color: "#F4EDE0", opacity: 0.85 }}>
                <span className="absolute right-0 top-3" style={{ width: "8px", height: "1px", backgroundColor: "#F4EDE0", opacity: 0.4 }} />
                {a}
              </li>
            ))}
          </ul>
        </Section>

        <div className="brush-divider my-16" />

        <div className="text-center">
          <a
            href="/lev-kazaryan-resume.pdf"
            download="Lev-Kazaryan-Resume.pdf"
            className="inline-flex items-center gap-2 px-6 py-3 border text-sm tracking-wide transition-all duration-500 hover:bg-parchment hover:text-navy"
            style={{ borderColor: "rgba(244, 237, 224, 0.5)", color: "#F4EDE0" }}
            data-testid="resume-download-pdf-bottom"
          >
            <Download size={14} />
            {t.download}
          </a>
        </div>
      </article>
    </main>
  );
}

function Section({ title, icon, children }) {
  return (
    <section className="mb-16">
      <div className="flex items-center gap-3 mb-6">
        {icon && <span style={{ color: "#F4EDE0", opacity: 0.55 }}>{icon}</span>}
        <p style={{ color: "#F4EDE0", opacity: 0.55, letterSpacing: "0.3em", fontSize: "11px", textTransform: "uppercase" }}>
          {title}
        </p>
      </div>
      {children}
    </section>
  );
}

export default function Resume() {
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      setUnlocked(true);
    }
  }, []);

  if (!unlocked) return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  return <ResumeContent />;
}
